import { useState, useEffect } from 'react';
import { render } from 'react-dom';
const $ = jQuery;
import 'swiper/css/bundle'; // Swiper CSS

import DisplayPosts from './DisplayPosts';
import Pagination from './Pagination';
import './style.scss';
import { sliderConfig, setSliderHeight, tickerConfig } from './utils/configs';

// Advanced Posts Block
document.addEventListener('DOMContentLoaded', () => {
	const allApbPosts = document.querySelectorAll('.wp-block-ap-block-posts');
	allApbPosts.forEach(apbPosts => {
		const attributes = JSON.parse(apbPosts.dataset.attributes);
		const { totalPosts } = JSON.parse(apbPosts.dataset.extra);
		const { layout } = attributes;

		// Slider
		if ('slider' === layout) {
			const sliderEl = document.querySelector(`#${apbPosts.id} .apbSliderPosts`);

			if (sliderEl) {
				new Swiper(sliderEl, sliderConfig(attributes));
				// new Swiper(sliderEl, {
				// 	...sliderConfig(attributes),
				// 	on: {
				// 		init: () => {
				// 			const slideWrapperEl = document.querySelector(`#${apbPosts.id} .apbSliderPosts .swiper-wrapper`);
				// 			slideWrapperEl.className = 'swiper-wrapper';
				// 			slideWrapperEl.style.gap = 0;
				// 		}
				// 	}
				// });

				// Slider Height
				setSliderHeight(apbPosts.id);
			}
		}


		// Ticker
		if ('ticker' === layout) {
			const tickerEl = document.querySelector(`#${apbPosts.id} .apbTickerPosts`);

			tickerEl && $(tickerEl).easyTicker(tickerConfig(attributes));
		}

		render(<RenderMain apbPosts={apbPosts} totalPosts={totalPosts} attributes={attributes} />, document.querySelector(`#${apbPosts.id} .apbPostsMain`));

		apbPosts?.removeAttribute('data-attributes');
		apbPosts?.removeAttribute('data-extra');
	});
});

const RenderMain = ({ apbPosts, totalPosts, attributes }) => {
	const { cId, layout, isPostsPerPageAll, postsPerPage, postsOffset, isPagination, paginationPrevLabel, paginationNextLabel, fImgSize } = attributes;

	const [posts, setPosts] = useState([]);

	const apbPostsMainPHEl = document.querySelector(`#${apbPosts.id} .apbPostsMainPH`);

	// Remove PHP posts if has posts
	useEffect(() => {
		posts?.length && apbPostsMainPHEl?.remove();
	}, [posts, apbPostsMainPHEl]);

	return <>
		{posts?.length ? <DisplayPosts posts={posts} attributes={attributes} clientId={cId} /> : null}

		<Pagination attributes={{ layout, isPostsPerPageAll, postsPerPage, isPagination, paginationPrevLabel, paginationNextLabel }} totalCount={totalPosts} onChange={val => {
			// window.scrollTo({
			// 	top: apbPosts.offsetTop,
			// 	behavior: 'smooth',
			// });

			// Fetch posts on page click
			fetch(`${apbPageData?.ajaxUrl}?action=apb_get_posts&cId=${cId}&pageNumber=${val}&postsPerPage=${postsPerPage}&postsOffset=${postsOffset}&fImgSize=${fImgSize}`)
				.then(res => res.json())
				.then(data => setPosts(data));
		}} />
	</>
}